import { useEffect } from 'react';

import { useSuspenseQuery } from '@tanstack/react-query';
import { useLocation, useNavigate } from 'react-router-dom';

import { getActiveUser } from '../api/magellan/users';

export function useActiveUserQuery() {
  const navigate = useNavigate();
  const location = useLocation();
  const query = useSuspenseQuery({
    queryKey: [getActiveUser.name],
    queryFn: getActiveUser,
  });

  useEffect(() => {
    if (!query.data.user.activeWorkspace) {
      navigate('/workspace-not-found');
    } else if (location.pathname === '/workspace-not-found') {
      navigate('/');
    }
  }, [location.pathname, navigate, query.data.user.activeWorkspace]);

  return query;
}
